import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=33657931&scoped=true&"
import script from "./PublishButton.vue?vue&type=script&lang=ts&"
export * from "./PublishButton.vue?vue&type=script&lang=ts&"
import style0 from "./PublishButton.vue?vue&type=style&index=0&id=33657931&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33657931",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VOtpInput})
